import { memo } from "react";
import { Scrollbars } from "@tecorien/mimic-v2";
import classNames from "classnames";
import { MenuListProps } from "react-select";

import styles from "./style.module.scss";

export const MenuList = memo<MenuListProps<any>>((props) => {
  const { children, className, cx, getStyles, isMulti, innerRef } = props;

  const selectStyles = { ...getStyles("menuList", props) } as any;
  return (
    <div
      style={{
        ...selectStyles,
        overflow: "hidden",
        "--maxHeight": typeof selectStyles.maxHeight === "number" ? `${selectStyles.maxHeight}px` : selectStyles.maxHeight,
      }}
      className={classNames(
        cx(
          {
            "menu-list": true,
            "menu-list--is-multi": isMulti,
          },
          className),
        styles.menuList,
      )}
    >
      <Scrollbars
        className={styles.menuListScrollbar}
        ref={(ref) => (innerRef as any)(ref?.osInstance()
          ?.elements()?.viewport)}
      >
        {children}
      </Scrollbars>
    </div>
  );
});
